import React from "react";
import styled from "styled-components";
import {Colors} from "../constants";


export const TabContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 20vw;
height: 100%;
cursor: pointer;
color: ${Colors.button};
:hover {
background-color: rgba(255,255,255,0.3);
border-radius: 13px 13px 0 0;
}
`;